import { epgChannelsModel } from '$/epg/channels'
import { NO_EPG_ID, epgProgramsModel } from '$/epg/programs'
import { combine, createEvent, createStore } from 'effector'
import { activeProgramModel } from '~/features/epg/active-program'
import { type Selected } from './index.h'

export const select = createEvent<Selected>()
export const deselect = createEvent()
export const $selected = createStore<Selected | null>(null)
  .reset(deselect)
  .on(select, (_, selected) => selected)

// currently selected channel with program in sidebar
export const $program = combine(
  {
    selected: $selected,
    all: epgChannelsModel.$all,
    epg: epgProgramsModel.$epg,
    currentProgram: activeProgramModel.$currentProgram,
  },
  ({ selected, all: [channels], epg: [programs], currentProgram }) => {
    if (!selected && !currentProgram) return null
    const channelId = selected?.channelId ?? currentProgram?.channelId

    if (!channelId) return null

    const channel = channels.get(channelId)

    if (channel == null) return null

    const program = programs.get(channel.channelEpgId ?? NO_EPG_ID)
    if (program == null) return null
    const programId = selected?.programId ?? currentProgram?.programId
    if (!programId) return null
    const chosen = program.find((p) => p.id === programId)

    const timeParams: { actualStartMs?: number; actualStopMs?: number } = {}
    if (!selected) {
      if (currentProgram?.actualStartMs != null) {
        timeParams.actualStartMs = currentProgram.actualStartMs
      }
      if (currentProgram?.actualStopMs != null) {
        timeParams.actualStopMs = currentProgram.actualStopMs
      }
    }

    const programExtendedWithCatchupFields =
      chosen || selected
        ? {
            ...chosen,
            ...selected,
            ...timeParams,
          }
        : null

    return { channel, program: programExtendedWithCatchupFields }
  }
)
